import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SocioData from '../../services/socio-service';
import './dashboard.css';

export const Dashboard = ({ accessToken }) => {
  const [data, setData] = useState(null);
  const [initLoaded, setInitLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sociogramData = await SocioData.getSociogramList(accessToken);
        setData(sociogramData);
        setInitLoaded(true);
      } catch (error) {
        setError(true);
        setInitLoaded(true);
      }
    };

    fetchData();
  }, [accessToken]);

  const formatDate = (secondsDate) => {
    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(secondsDate);
    return d.getDate() + "/" + d.getMonth() + "/" + d.getFullYear() + " - " + d.getHours() + ":" + d.getMinutes() + "." + d.getSeconds();
  };

  if (error) {
    return (
      <div>
        <h1>You are not authenticated</h1>
        <Link to="/">
          <button className="btn btn-primary btn-block contact">
            Back home
          </button>
        </Link>
      </div>
    );
  } else if (!data && !initLoaded) {
    return (
      <div>
        <h1>Loading..</h1>
      </div>
    );
  } else if (!data) {
    return (
      <div>
        <h1>You have not created any sociograms yet</h1>
        <Link to="/create">
          <button className="btn btn-primary btn-block contact">
            Create New Sociogram
          </button>
        </Link>
      </div>
    );
  }

  const rows = data.map((item, i) => {
    const socioLink = "/sociogram/" + item.id;
    // only count people if people are configured for the sociogram
    let personCount = 0;
    if (item.people) personCount = item.people.length;
    
    return (
      <div className="three-rows" key={item.id || i}>
        <div>
          <Link to={socioLink}>
            {item.name}
          </Link>
        </div>
        <div>
          {formatDate(item.createdAt / 1000)}
        </div>
        <div>
          {personCount}
        </div>
      </div>
    );
  });

  return (
    <div className="dash-parent">
      <h1>Here are the sociograms you have created so far..</h1>
      <div className="dash-header">
        <div>Name</div>
        <div>Created</div>
        <div>Number of people</div>
      </div>
      {rows}
    </div>
  );
};

export default Dashboard;